import { FadeInEntrances } from 'helpers/animation';
import React from 'react';
import styled from 'styled-components';

const FadeSectionWrap = ({ children }) => {
  return <FadeSection>{children}</FadeSection>;
};

const FadeSection = styled.div`
  ${FadeInEntrances}
`;

export default FadeSectionWrap;
